import { QuestionnaireResponseItemAnswer } from '@medplum/fhirtypes'
import { sanitizeCodeableConceptCode } from 'fhir/utils'
import { BaseQuestionnaireFragment } from 'generated/graphql'

/**
 * A helper to create a valueCoding QuestionnaireResponseItem object
 * @param code LOINC code or Abbycare code identifying the CodeableConcept
 * @param display Display string
 * @returns valueCoding QuestionnaireResponseItem object
 */
export const createValueCodingAnswer = ({
  code,
  display
}: {
  code: string
  display: string
}): QuestionnaireResponseItemAnswer => ({
  valueCoding: {
    code: sanitizeCodeableConceptCode(code),
    display
  }
})

export const getIdentifierValueByQuestionnaire = (
  questionnaire: BaseQuestionnaireFragment
): string => {
  const identifiers = questionnaire?.identifier ?? []

  const questionnaireTypeIdentifier = identifiers?.find((i) => i.system == 'type')

  return questionnaireTypeIdentifier?.value ?? ''
}
